// firebase.js

import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyAVdxA72umnGGYfoD06BFO393b5yXC0nqs',
  authDomain: 'srmd-reports.firebaseapp.com',
  projectId: 'srmd-reports',
  storageBucket: 'srmd-reports.appspot.com',
  messagingSenderId: '903339333527',
  appId: '1:903339333527:web:5fa9d4b10876369cfc16d2',
  measurementId: 'G-MB88FE415B',
};

firebase.initializeApp(firebaseConfig);

/*
  IMPORTANT: firebase.messaging() must never be called unconditionally at module
  scope.

  Internally, Firebase's WindowMessagingFactory runs
  `navigator.serviceWorker.addEventListener(...)` synchronously, with no guard
  (Firebase's own isSupported() check is async and cannot protect it). So:

    - Safari with "Block All Cookies" / blocked site data, or private browsing,
      throws `SecurityError: The operation is insecure.` on the mere *access*
      of navigator.serviceWorker.
    - Any browser without service worker support throws a TypeError.

  Because this module is imported (via Login/Projections -> App) on every route,
  an uncaught throw here happens before ReactDOM.render() and leaves the user
  with a blank white page on every page of the app, including /epass/:passId
  which does not use Firebase at all.

  Everything below is therefore defensive, and `messaging` may legitimately be
  null. Callers MUST null-check before using it.
*/
const isMessagingSupported = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      typeof navigator !== 'undefined' &&
      'serviceWorker' in navigator &&
      // Accessing the property itself can throw in Safari when site data is blocked.
      !!navigator.serviceWorker &&
      'PushManager' in window &&
      'Notification' in window
    );
  } catch (err) {
    console.warn('[firebase] messaging support check failed:', err);
    return false;
  }
};

let messaging = null;

if (isMessagingSupported()) {
  try {
    messaging = firebase.messaging();
  } catch (err) {
    console.warn('[firebase] messaging unavailable, continuing without push:', err);
    messaging = null;
  }
} else {
  console.info('[firebase] push messaging not supported in this browser/context.');
}

export { messaging };
